import React from 'react';
import styles from './styles.module.scss';
import classNames from 'classnames';

export const Caption: React.FC<{ className?: string }> = ({ children, className }) => {
    return <div className={classNames(styles.caption, className)}>{children}</div>;
};
